import type { OutreachTargetKind } from 'fym-shared/src/music24/outreach/types';

/** The target kinds an artist can search. `community` is reference-only, never a Find tab or a send. */
export type SearchableTargetKind = Exclude<OutreachTargetKind, 'community'>;

/** The tabs of Find in order (design outreach c1): playlists first, creators last. */
export const FIND_KINDS: readonly SearchableTargetKind[] = [
  'playlist',
  'press',
  'newsletter',
  'radio',
  'podcast',
  'creator',
];

/** The follower presets of the filter bar (design c1 "1k – 60k"). */
export const FOLLOWER_PRESETS = {
  any: { min: null, max: null },
  small: { min: null, max: 999 },
  mid: { min: 1000, max: 60000 },
  big: { min: 60001, max: null },
} as const;

export type FollowerPreset = keyof typeof FOLLOWER_PRESETS;
